import { dashboardT } from '../../../../../lib/messages';
import { readShigoAppConfig } from '../../../../../lib/config';
import { useAgencyCampaignContext } from '../../../agencyCampaignContext';
import { useAgencyOptions } from '../../../../supply/agency/hooks';
import type { AssignedAgency } from '../../../../auth/agencyAccess';
import { BrandDialog } from '../BrandDialog';
import { useIndustriesQuery, useBrandQuery } from '../../hooks';
import type { Brand } from '../../model';
import { resolveBrandIndustries } from './brandEditorHelpers';
import { useBrandEditorSave } from './useBrandEditorSave';

export function BrandEditorDialog({
  brand: initialBrand,
  parentAgency,
  onClose,
}: {
  brand: Brand | null;
  parentAgency?: AssignedAgency | undefined;
  onClose: () => void;
}) {
  const scope = useAgencyCampaignContext();
  const canAdminAgency = !scope;
  const { networkId } = readShigoAppConfig();
  const agencyOptions = useAgencyOptions(networkId, canAdminAgency && !parentAgency);
  const details = useBrandQuery(initialBrand?.id ?? '');
  const brand = details.data ?? initialBrand;
  const assignedAgency = scope?.agency ?? parentAgency ?? brand?.agency ?? undefined;
  const save = useBrandEditorSave({ brand, scopeAgencyId: scope?.agency.id, assignedAgency });
  const industries = useIndustriesQuery();
  const savesThroughDemandApi = canAdminAgency || Boolean(scope);
  if (initialBrand && details.isError) return <p role="alert">{dashboardT('brands.loadError')}</p>;
  if (initialBrand && !details.isSuccess)
    return <p role="status">{dashboardT('brands.loading')}</p>;
  return (
    <BrandDialog
      scoped={Boolean(scope || parentAgency)}
      agency={assignedAgency}
      prepareAgency={savesThroughDemandApi}
      agencies={agencyOptions.data ?? []}
      {...(savesThroughDemandApi ? { onSave: save } : {})}
      brand={brand}
      industries={resolveBrandIndustries(industries.data, brand)}
      onClose={onClose}
    />
  );
}
